import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-feead474"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "progress-bar__visual",
  "data-bar": ""
}
const _hoisted_2 = { class: "progress-bar__percentage" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['progress-bar', _ctx.theme]),
    ref: "progressBar"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: "progress-bar__after",
        style: _normalizeStyle({ width: _ctx.filledPercentage + '%' }),
        "data-progress": ""
      }, null, 4)
    ]),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.filledPercentage) + "%", 1)
  ], 2))
}